import React from "react"
import Card from "../../../../components/Card/Card"
import AuthorHeader from "../AuthorHeader"
import TicketActivity from "../TicketActivity"
import Hr from "../../../../components/Hr"

const TicketComment = ({
    comment
}) => {
    return (
        <Card className="min-h-18">
            <div>
                <AuthorHeader
                    email={comment.author?.email}
                    name={comment.author?.name}
                    avatar={comment.author?.avatar}
                    datetime={comment.datetime}
                />
            </div>

            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <Hr />
            </div>

            <div>
                <TicketActivity
                    contentHtml={comment.comment}
                />
            </div>
        </Card>
    )
}

export default TicketComment